import styled from "styled-components";

const ResolverTextGroup = styled.div`
  display: contents;
`;

export default ResolverTextGroup;
